export const isClassElement = (element, className) =>
  !!element?.classList?.contains(className);
